import { AxiosRequestHeaders } from 'axios';
import { AutorZmeny as AutorZmenyDto, AutorZmenyListApi } from 'tezaury-frontend-ts-axios';
import { ClientResponse } from '../model/ClientResponse';
import apiConfiguration from './configuration/apiConfiguration';
import { tezauryPrefixPath } from './configuration/apiConfigurationConstants';
import { Pouzivatel } from '../model/Pouzivatel';
import Uuid from '../model/Uuid';

const client = new AutorZmenyListApi(apiConfiguration(tezauryPrefixPath));

function map(autorZmenyList: AutorZmenyDto[]): Pouzivatel[] {
  return autorZmenyList.map(autorZmeny => ({
    uuid: autorZmeny.uuid,
    nazov: autorZmeny.celeMeno,
    priezvisko: autorZmeny.priezvisko,
  }));
}

// eslint-disable-next-line import/prefer-default-export
export const fetchAutorZmenyList = async (
  tezaurusUuid: Uuid,
  options: { headers?: AxiosRequestHeaders } = {},
): Promise<ClientResponse<Pouzivatel[]>> => {
  const {
    data,
    status,
  } = await client.getAutorZmenyList(
    tezaurusUuid,
    options,
  );

  return {
    data: map(data),
    responseCode: status,
  };
};
